import { render, staticRenderFns } from "./ClosedDays.vue?vue&type=template&id=a4d94bc4&scoped=true&"
import script from "./ClosedDays.vue?vue&type=script&lang=js&"
export * from "./ClosedDays.vue?vue&type=script&lang=js&"
import style0 from "./ClosedDays.vue?vue&type=style&index=0&id=a4d94bc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d94bc4",
  null
  
)

export default component.exports